import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';
import { merge } from 'lodash-es';

const mergedTokens = merge(templateThemeTokens, {
  colors: {
    defaultFont: '$brandBlack',
    pageBackground: '$white',
  },
  fonts: {
    accent: THEME_DEFAULT_FONTS.madrid.midday.accent
      ? THEME_DEFAULT_FONTS.madrid.midday.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.madrid.midday.body.value,
    heading: THEME_DEFAULT_FONTS.madrid.midday.headline.value,
  },
});

export const midday = createTheme({ ...mergedTokens });
